<ng-container>
  <biometrics-display
    [userId]="patientId"
    [visitId]="visitId()"
    [showLogsButton]="showLogsButton()"
    [restartPolling] = "restartPolling()"
    (viewLogsClick)="onViewLogsClick()"
  ></biometrics-display>
</ng-container>
